

import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Utilities } from '../../../common/utilities';
import { BOOdontologyBackgroundType } from '../../../models/odo/BOOdontologyBackgroundType.model';
import { OdontologyBackgroundTypeService } from '../../../services/odo/OdontologyBackgroundType.service';

 @Component({
  selector: 'app-odontology-patient-background',
  templateUrl: './odontology-patient-background.component.html',
  styleUrls: ['./odontology-patient-background.component.css']
})
export class OdontologyPatientBackgroundComponent implements OnInit
{

    @Input() id!: number;
    @Input() itemType!: string;
    @Input() itemName!: string;
    @Input() details!: string;
    @Input() posInArray!:number;
    @Input() uniqueId!: string;
    @Output() posSended = new EventEmitter<{ uniqueId: string }>(); // ← Cambia el tipo
    @Output() posSendedId = new EventEmitter<{ itemId: number, tipo:string, details:string }>(); // ← Cambia el tipo


  backgroundTypeList:BOOdontologyBackgroundType[]=[];


  constructor( private _formBuilder : FormBuilder,
               private _odontologyBackgroundTypeService      : OdontologyBackgroundTypeService
  )
  { }

  backgroundFormGroup = this._formBuilder.group({
    posInArray:{ value: null, disabled: true },
    itemName: { value: null, disabled: true },
    details: { value: null},
  })

  ngOnInit(): void {

    this._odontologyBackgroundTypeService.getAll().subscribe({
      next:(data)=>
      {

        this.backgroundTypeList=data;

        this.backgroundFormGroup.patchValue({
        posInArray: this.posInArray +1,
        itemName: Utilities.getRelativeTypeName(this.itemType, this.backgroundTypeList),
        details:this.details
       })

      },
      error:(err)=>{
        console.log("Ocurrió un error en la descarga de tipo parientes");
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Evitamos el primer cambio porque ngOnInit ya lo maneja
    if (changes['posInArray'] && !changes['posInArray'].firstChange) {
      this.backgroundFormGroup.patchValue({
        posInArray: this.posInArray + 1
      });
    }
  }

deleteItem(): void {
  this.posSended.emit({ uniqueId: this.uniqueId }); // ← Emite ID, no posición
}

deleteItemSingle(): void {
  let details=this.backgroundFormGroup.get('details').value;
  this.posSendedId.emit({ itemId: this.id, tipo:'del', details:details}); // ← Emite ID, no posición
}


editItemSingle(): void {
   let detailsTemp=this.backgroundFormGroup.get('details').value;

  this.posSendedId.emit({ itemId: this.id, tipo:'edi', details:detailsTemp }); // ← Emite ID, no posición
}

}
